import { render, staticRenderFns } from "./PerformanceReportPage.vue?vue&type=template&id=995a6398&scoped=true"
import script from "./PerformanceReportPage.vue?vue&type=script&lang=js"
export * from "./PerformanceReportPage.vue?vue&type=script&lang=js"
import style0 from "./PerformanceReportPage.vue?vue&type=style&index=0&id=995a6398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995a6398",
  null
  
)

export default component.exports